import React from 'react';
import PropTypes from 'prop-types';
import Content from './Content';

export default function CreateEditTagModal(props) {
	const {
		showModal,
		setShowModal,
		labels,
		entityId,
		tagTypeId,
		isLoading,
		setIsLoading,
		onEntityCreated,
		isEditModal = false
	} = props;

	return (
		<Content
			isEditModal={isEditModal}
			labels={labels}
			showModal={showModal}
			setShowModal={setShowModal}
			onEntityCreated={onEntityCreated}
			entityId={entityId}
			isLoading={isLoading}
			setIsLoading={setIsLoading}
			tagTypeId={tagTypeId}
			{...props}
		/>
	);
}

CreateEditTagModal.propTypes = {
	engagementId: PropTypes.string,
	entityId: PropTypes.string,
	tagTypeId: PropTypes.string,
	showModal: PropTypes.bool,
	setShowModal: PropTypes.func,
	isCreate: PropTypes.bool,
	isLoading: PropTypes.bool,
	setIsLoading: PropTypes.func,
	onEntityCreated: PropTypes.func,
	labels: PropTypes.shape({
		createModalTitle: PropTypes.string,
		editModalTitle: PropTypes.string,
		createModalDescription: PropTypes.string,
		editModalDescription: PropTypes.string,
		tagNameLabel: PropTypes.string,
		tagGroupNameLabel: PropTypes.string,
		tagColorLabel: PropTypes.string,
		saveAndCloseLabel: PropTypes.string,
		saveAndCreateLabel: PropTypes.string,
		cancelLabel: PropTypes.string,
		required: PropTypes.string,
		noresultsLabel: PropTypes.string,
		tagColors: PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string,
				color: PropTypes.string
			})
		)
	})
};

CreateEditTagModal.defaultProps = {
	engagementId: null,
	showModal: false,
	entityId: null,
	tagTypeId: null,
	isLoading: false,
	setIsLoading: () => {},
	setShowModal: () => {},
	onEntityCreated: () => {},
	labels: {
		createModalTitle: 'New sample tag',
		editModalTitle: 'Edit sample tag',
		createModalDescription:
			"Enter tag details below and select '<b>Save and close</b>' to finish. To create another tag, select '<b>Save and create another</b>'.",
		editModalDescription: `Edit the tag details below and select '<b>{0}</b>' to finish.`,
		tagNameLabel: 'Tag name (required)',
		tagGroupNameLabel: 'Tag group name (required)',
		tagColorLabel: 'Color (required)',
		saveAndCloseLabel: 'Save and close',
		saveAndCreateLabel: 'Save and create another',
		cancelLabel: 'Cancel',
		required: 'Required',
		noresultsLabel: 'No tag groups available',
		tagColors: [
			{text: 'Red', color: 'red'},
			{text: 'Orange', color: 'orange'},
			{text: 'Teal', color: 'teal'},
			{text: 'Blue', color: 'blue'},
			{text: 'Purple', color: 'purple'},
			{text: 'Green', color: 'green'}
		]
	}
};
